define(() => {
    return (Transport) => {
        let WrappedTransport = Transport;
        WrappedTransport = ['$q', '$injector', 'EventHub', ($q, $injector, EventHub) => {
            const OriginalTransport = $injector.invoke(Transport);

            const WrappedSend = (xCenter, serviceEndpoint, method, params) => {
                const t0 = Date.now();
                return OriginalTransport.send(xCenter, serviceEndpoint, method, params)
                    .then((response) => {
                        const elapsed = Date.now() - t0;
                        EventHub.publish('tracking', 'serverCall', {
                            path: serviceEndpoint,
                            method,
                            success: true,
                            elapsedTime: elapsed,
                            params,
                            response
                        });
                        return response;
                    }, (error) => {
                        const elapsed = Date.now() - t0;
                        EventHub.publish('tracking', 'serverCall', {
                            path: serviceEndpoint,
                            method,
                            success: false,
                            elapsedTime: elapsed,
                            params,
                            error
                        });
                        return $q.reject(error);
                    });
            };

            return Object.assign(Object.create({}), OriginalTransport, {send: WrappedSend});
        }];
        return WrappedTransport;
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/tracking/transport.js